import * as React from 'react';
import { useEffect, useState } from 'react';

import { useLocation } from 'js/lib/useRouter';

import { VisuallyHidden } from '@coursera/cds-core';

import { responseMessageFactory } from 'bundles/authentication/constants';

const SignupSuccessAriaMessage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.query);
  const isSignupSuccess = params.get('authMode') === 'signupSuccess';
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    if (isSignupSuccess) {
      // Using state to delay the aria-live message announcement until after initial page load
      // This ensures screen readers will announce the success message, as they may ignore
      // content present in aria-live regions during the initial page load
      setShowMessage(true);
      // Clear the signupSuccess query parameter without causing a page redirect
      const newParams = new URLSearchParams(window.location.search);
      newParams.delete('authMode');
      const newSearch = newParams.toString();
      const newUrl = `${window.location.pathname}${newSearch ? `?${newSearch}` : ''}`;
      window.history.replaceState({}, '', newUrl);
    }
  }, [isSignupSuccess]);

  return (
    <VisuallyHidden aria-live="assertive">
      {showMessage && (
        <div data-testid="ariaSignupSuccessMessage">
          <p>{responseMessageFactory().successRedirect}</p>
        </div>
      )}
    </VisuallyHidden>
  );
};

export default SignupSuccessAriaMessage;
